import React from "react";
import TotalTicket from "./TotalTicket";
import OverallTat from "../OverallTat/FirstLevelResponse";
import NewTicket from "../NewTicket";
import AgentNewTicket from "../AgentNewTicket";
import Header from "./Header";

const TicketTat = ({ widgetsData, BasicCharts, dashboard,widgetName,widgetDec }) => {

	if (
		widgetsData?.widget_id === "tickets_simple-view_2" ||
		widgetsData?.widget_id === "tickets_simple-view_6"
	) {
		return (
			<div className="portlet1 p-0 mb-15">
				{!dashboard && (
					<Header
						BasicCharts={BasicCharts}
						data={widgetsData?.graphData ? widgetsData?.graphData : widgetsData}
						value={true}
						id={widgetsData?.widget_id}
						widgetsData={widgetsData}
						widgetName={widgetName}
						widgetDec={widgetDec}
					/>
				)}
				<TotalTicket
				    id={widgetsData?.widget_id}
					totalsTicketwidget={
						widgetsData?.graphData ? widgetsData?.graphData : widgetsData
					}
				/>
			</div>
		);
	} else if (widgetsData?.widget_id === "tickets_simple-view_1") {
		return (
			<>
				<div
					className={`bg-white ${
						widgetsData?.type === "predefined" ? "d-none" : ""
					}`}
				>
					{!dashboard && (
						<Header
							BasicCharts={BasicCharts}
							value={false}
							data={
								widgetsData?.graphData ? widgetsData?.graphData : widgetsData
							}
							id={widgetsData?.widget_id}
							widgetsData={widgetsData}
							widgetName={widgetName}
						    widgetDec={widgetDec}
						/>
					)}
				</div>
				<div className="mb-15">
					<NewTicket
						totalsTicketwidget={
							widgetsData?.graphData ? widgetsData?.graphData : widgetsData
						}
					/>
				</div>
			</>
		);
	} else if (widgetsData?.widget_id === "tickets_simple-view_5") {
		return (
			<>
				<div
					className={`bg-white ${
						widgetsData?.type === "predefined" ? "d-none" : ""
					}`}
				>
					{!dashboard && (
						<Header
							BasicCharts={BasicCharts}
							value={false}
							data={
								widgetsData?.graphData ? widgetsData?.graphData : widgetsData
							}
							id={widgetsData?.widget_id}
							widgetsData={widgetsData}
							widgetName={widgetName}
					     	widgetDec={widgetDec}
						/>
					)}
				</div>
				<div className="mb-15">
					<AgentNewTicket
						totalsTicketwidget={
							widgetsData?.graphData ? widgetsData?.graphData : widgetsData
						}
					/>
				</div>
			</>
		);
	} else if (
		widgetsData?.widget_id === "tickets_simple-view_3" ||
		widgetsData?.widget_id === "tickets_simple-view_4" ||
		widgetsData?.widget_id === "tickets_simple-view_7" ||
		widgetsData?.widget_id === "tickets_simple-view_8"
	) {
		return (
			<div className="portlet1 p-0 mb-15">
				{!dashboard && (
					<Header
						BasicCharts={BasicCharts}
						value={false}
						data={widgetsData?.graphData ? widgetsData?.graphData : widgetsData}
						id={widgetsData?.widget_id}
						widgetsData={widgetsData}
						widgetName={widgetName}
						widgetDec={widgetDec}
					/>
				)}
				<OverallTat
					id={widgetsData?.widget_id}
					overallTatwidget={
						widgetsData?.graphData ? widgetsData?.graphData : widgetsData
					}
				/>
			</div>
		);
	} else {
		return <div>No data</div>;
	}
};

export default TicketTat;
